import { STATUS } from './constants';

/**
 * Determines approval status based on make and model status
 * @param {string} makeStatus - Status of the make
 * @param {string} modelStatus - Status of the model
 * @returns {string} - Combined approval status
 */
const getApprovalStatusFromMakeModel = (makeStatus, modelStatus) => {
  if (makeStatus === STATUS.REJECTED || modelStatus === STATUS.REJECTED) {
    return STATUS.REJECTED;
  }

  if (makeStatus === STATUS.PENDING_REVIEW || modelStatus === STATUS.PENDING_REVIEW) {
    return STATUS.PENDING_REVIEW;
  }

  if (makeStatus === STATUS.APPROVED && modelStatus === STATUS.APPROVED) {
    return STATUS.APPROVED;
  }

  return STATUS.PENDING_REVIEW;
};

/**
 * Gets the make/model approval status for items that might include a chassis tag
 * @param {Object} item - The item object
 * @param {boolean} isSINRequiresChassis - Indicates if the SIN requires a chassis
 * @returns {string} - Approval status
 */
const getMakeModelApprovalStatus = (item, isSINRequiresChassis) => {
  if (isSINRequiresChassis && item?.makeModelApproval?.fleetApprovalStatus) {
    return item.makeModelApproval.fleetApprovalStatus;
  }
  return getApprovalStatusFromMakeModel(
    item?.make?.fleetStatus,
    item?.model?.fleetStatus,
  );
};

export const getPreBidAndBidMakeModelApprovalStatus = (item, isSINRequiresChassis) => {
  return getMakeModelApprovalStatus(item, isSINRequiresChassis);
};

export const getContractMakeModelApprovalStatus = (
  item,
  isSINRequiresChassis,
  isSOP,
  isAwardedInFleet,
) => {
  if (isSOP && isAwardedInFleet) {
    return getMakeModelApprovalStatus(item, isSINRequiresChassis);
  }

  // handles both legacy sop and non-sop flow
  return getApprovalStatusFromMakeModel(
    item?.make?.fleetStatus,
    item?.model?.fleetStatus,
  );
};
